import { useState, useEffect } from "react";
import { getList } from "../api/search";

function useEntitiesList(category, orderBy, whereClause, initialGlobalFilter) {

    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(initialGlobalFilter);
    const [refresh, setRefresh] = useState(1);

    async function loadData() {
        setLoading(true);
        try {

            let items = await getList(category, orderBy || "updatedat desc", whereClause || "1=1");
            setResult(items);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadData();
    }, [refresh]);

    function forceRefresh() {
        setRefresh(refresh + 1);
    }

    return [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh];
}

export default useEntitiesList;
